import { render, staticRenderFns } from "./binding-application.vue?vue&type=template&id=49497c67&scoped=true&"
import script from "./binding-application.vue?vue&type=script&lang=js&"
export * from "./binding-application.vue?vue&type=script&lang=js&"
import style0 from "./binding-application.vue?vue&type=style&index=0&id=49497c67&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49497c67",
  null
  
)

export default component.exports